import { AppValidatorPattern } from './app.validator-pattern';

export class AppValidationMessages {
  static readonly REQUIRED_MSG = `is required`;

  static MIN_LENGTH_MSG = (length: number = AppValidatorPattern.MIN_LENGTH) =>
    `must be at least ${length} characters long`;
  static MAX_LENGTH_MSG = (length: number = AppValidatorPattern.MAX_LENGTH) =>
    `cannot exceed ${length} characters`;
  static TEXTAREA_MAX_LENGTH_MSG = (
    length: number = AppValidatorPattern.TEXTAREA_MAX_LENGTH
  ) => `cannot exceed ${length} characters.`;

  static readonly INVALID_CHARACTERS_MSG = `contains invalid characters`;
  static readonly ALL_ZERO_PHONE_MSG = `cannot contains all zeros`;
  static readonly INVALID_CARD = `Invalid card number`;
  static readonly INVALID_DATE_FORMAT = `Invalid date format`;
  static readonly INVALID_MONTH = `Invalid month.`;
  static readonly ONLY_NUMBERS = `must be numeric`;
  static readonly NO_SPACES_MSG = `cannot contain spaces`;
  static readonly LEADING_TRAILING_SPACES_MSG = `cannot contain leading or trailing spaces`;
  static readonly ALPHANUMERIC_NO_SPACES_MSG = `must be alphanumeric with no spaces`;
  static readonly CODE_IN_USE_MSG = `Code Already In Use`;
  static readonly INVALID_DATA_MESSAGE = `Invalid form data.`;
  static readonly NO_MACHING_ROW_DATA = `No matching row found.`;
  static readonly INVALID_CURRENCY_MSG = `Please enter a valid currency amount (e.g., 123.45).`;
  static readonly CURRENCY_MIN_MSG = `must be greater than zero.`;
  static readonly CURRENCY_MAX_MSG = `exceeds the maximum allowed value.`;
  static readonly AMOUNT_MAX_DIGITS_MSG =
    'Amount more than 10 digits are not allowed';
  // Contact validation messages
  static readonly INVALID_PHONE_MSG = `Please enter a valid phone number (exactly 10 digits, cannot start with 0, e.g., 1234567890).`;
  static readonly PHONE_TYPE_REQUIRED_MSG = `Please choose a phone type from the list`;
  static readonly COUNTRY_CODE_REQUIRED_MSG = `Please select your country code`;
  static readonly PLATFORM_REQUIRED_MSG = `Please select or enter a valid platform.`;
  static readonly INVALID_URL_MSG = `Please enter a valid URL (start with http:// or https://).`;
  static readonly EMAIL_TYPE_REQUIRED_MSG = `Please choose an email type from the list.`;
  static readonly INVALID_EMAIL_MSG = `Please enter a valid email address.`;
  static readonly MAX_DB_LENGTH_MSG = `cannot exceed more than 250 characters`;

  // Numeric validation
  static readonly MIN_MSG = `must be greater than or equal zero.`;
  static readonly MAX_MSG = `exceeds the maximum allowed value.`;
  static readonly NEGATIVE_NOT_ALLOWED_MSG = `cannot be negative.`;

  // Currency / number formatting
  static readonly INVALID_NUMBER_MSG = `Please enter a valid number.`;

  // Date validation
  static readonly FUTURE_DATE_MSG = `Date cannot be in the future.`;
  static readonly PAST_DATE_MSG = `Date cannot be in the past.`;
  static readonly DATE_AFTER_MSG = `must be after`;
  static readonly DATE_BEFORE_MSG = `must be before`;
  static readonly DEPENDENCY_DATE_MISSING_MSG = `is required to validate`;
  static readonly INVALID_YEAR_RANGE =
    'Date must be between years 1900 and 2200';
  static readonly DATE_BEFORE_28 = `Servicing limitation, date must be on or before the 28th of the month.`;

  // Select type
  static readonly SELECT_REQUIRED = `Please select a`;

  static readonly PAYMENT_AMOUNT_REQUIRED = `Please enter a payment amount.`;
  static readonly FAIR_MARKET_REQUIRED = `Please enter the Fair Market Value.`;
  static readonly AMOUNT_FROM_SALE_REQUIRED = `Please enter the amount from sale.`;
  static readonly VALID_AMOUNT = `Please enter a valid number for the amount from sale.`;

  // Generic toast messages
  static readonly CREATE_MSG = `created successfully`;
  static readonly ADD_MSG = `added successfully`;
  static readonly UPDATE_MSG = `updated successfully`;
  static readonly DELETE_MSG = `deleted successfully`;
  static readonly SOMETHING_WENT_WRONG = `Something went wrong. Please try again.`;
  static readonly SOMETHING_WENT_WRONG_MSG = `Something went wrong`;
  static readonly PASSWORD_REQUIREMENTS_MSG = `Password does not meet all requirements.`;

  // Donation-related toast messages
  static readonly DELETE_RECORD = `Record successfully deleted.`;
  static readonly REFUND_SUCCESS = `Refund successfully processed.`;
  static readonly VOID_SUCCESS = `Transaction successfully voided.`;

  static readonly ASSIGN_CMP = `is already assigned to the company`;
  static readonly CONTACT_PEOPLE = `Please enter at least one search criteria (first name, last name, email, or phone)`;
  static readonly COMPANY_SUCCESS = `has been successfully assigned to the company.`;

  //send email modal
  static readonly BODY_EMPTY =
    'Body cannot be empty or contain only whitespace';
  static readonly MESSAGE_MAX_LIMIT = 'Message cannot exceed 10,000 characters';

  static readonly SENT_REMINDER_SUCCESS = `Reminder sent successfully!`;
  static readonly APPLICATION_SAVED_SUCCESS = `Application saved successfully!`;
  static readonly TUITION_FEE_EXCEEDED = `Requested loan amount should not be greater than tuition fees:`;
  static readonly DOCUMENT_STATUS_UPDATED_SUCCESS = 'Document status updated successfully';

  //consent
  static readonly SSN_REQUIRED_MSG =  `Please enter a valid 9-digit Social Security Number`;
  static readonly CREDIT_PULL_REQUIRED_MSG = `Authorization is required to proceed`;
  static readonly CREDIT_POLICY_REQUIRED_MSG = `You must agree to the credit policy`;
  static readonly ELECTRONIC_COM_REQUIRED_MSG = `You must agree to the electronic communications policy`;
  // Edit Details button tooltip messages
  static readonly EDIT_DISABLED_FINAL_DISCLOSURE_OPERATIONS_ADMIN =
    'A loan agreement has been created. To make changes, the loan agreement must be canceled first.';
  static readonly EDIT_DISABLED_FINAL_DISCLOSURE_APPLICANT =
    'Your loan agreement has been created and changes are no longer allowed. Please contact support for assistance.';
  static readonly EDIT_DISABLED_APPLICATION_SUBMITTED =
    'Your application has been submitted. To make changes, please contact support.';
  static readonly AGREEMENT_CREATE_APPROVAL_REQUIRED =
    'Application must be approved before an agreement can be created.';
    static readonly OFFER_SAVED_SUCCESS = 'Offer saved successfully.';
    static readonly INVITATION_SENT_SUCCESS = 'Invitation sent successfully!';
    static readonly PROGRAM_INFO_SAVED_SUCCESS = 'Program information saved successfully';
    static readonly CONTACT_DETAILS_SAVED_SUCCESS = 'Contact details saved successfully';
    static readonly HOUSING_SAVED_SUCCESS = 'Housing details saved successfully';
    static readonly CONSENT_DETAILS_SAVED_SUCCESS = 'Consent details saved successfully';
    static readonly REFERENCES_SAVED_SUCCESS = 'References saved successfully';
    static readonly APPLICATION_SUBMITTED_SUCCESS = 'Application submitted successfully';
    static readonly SUBMIT_CO_BORROWER_SUCCESS = 'Information submitted successfully';
    static readonly REMIND_CO_BORROWER_SUCCESS = 'Reminder sent to co-borrower successfully';
    static readonly CREATE_LOAN_SUCCESS = 'Loan created successfully';  
    static readonly FUND_LOAN_SUCCESS = 'Loan funded successfully';
    static readonly CREATE_NOTE_SUCCESS = 'Note created successfully';  
    static readonly INVITE_CO_BORROWER_SUCCESS = 'Co-borrower invited successfully';
    static readonly ADDRESS_SAVED_SUCCESS = 'Address saved successfully';
    static readonly AGREEMENT_CREATED_SUCCESS = 'Agreement created successfully';
    static readonly DOCUMENT_CREATED_SUCCESS = 'Document created successfully';
    static readonly PASSWORD_RESET_EMAIL_SENT = 'Password reset email sent successfully';
    static readonly PASSWORD_DOES_NOT_MEET_REQUIREMENTS = 'Password does not meet requirements.';
    static readonly OTP_RESEND_SUCCESS = 'A new confirmation code has been sent to your email.';
    static readonly NOTE_UPDATED_SUCCESS = 'Note updated successfully';
    static readonly NOTE_DELETED_SUCCESS = 'Note deleted successfully';
    static readonly CO_BORROWER_REMOVED_SUCCESS = 'Co-borrower removed successfully';
    static readonly DOCUMENT_DELETED_SUCCESS = 'Document deleted successfully';
    static readonly BANK_ACCOUNT_SAVED_SUCCESS = 'Bank account details saved successfully';
    static readonly AGREEMENT_CANCELLED_SUCCESS = 'Agreement cancelled successfully';
    static readonly APPLICATION_STATUS_UPDATED_SUCCESS = 'Application status updated successfully';
    static readonly EMPLOYMENT_DETAILS_SAVED_SUCCESS = 'Employment details saved successfully';
    static readonly FILE_UPLOADED_SUCCESS = 'File uploaded successfully';
    static readonly FILE_REPLACED_SUCCESS = 'File replaced successfully';
    static readonly DOCUMENT_DETAILS_UPDATED_SUCCESS = 'Document details updated successfully';
    static readonly REFUND_REQUEST_SUBMITTED_SUCCESS = 'Refund request submitted successfully';
    static readonly SSN_UPDATED_SUCCESS = 'SSN updated successfully';
    static readonly APPLICATION_APPROVAL_REQUIRED_SECTIONS =
      'Application cannot be approved until all required sections are completed for both borrower and co-borrower.';
    static readonly NEED_COAPPLICANT_COBORROWER_EXISTS =
      `Coborrower already exists. Remove the existing coborrower to set to 'Need Coapplicant'.`;
    static readonly TASK_UPDATE_MESSAGE = `Task ${this.UPDATE_MSG}`;
    static readonly TASK_COMPLETED_SUCCESS = 'Task marked as complete successfully';
    static readonly TASK_REOPENED_SUCCESS = 'Task reopened successfully';
    static readonly TASK_DELETED_SUCCESS = 'Task deleted successfully';
    static readonly BORROWER_EDIT_DETAILS_TOOLTIP =  
      'Due to consent requirements, bank details can only be edited by the borrower.';
    static readonly ENROLLMENT_CONFIRMATION_REMINDER_SUCCESS = 'Enrollment confirmation reminder sent successfully';
    static readonly PROGRAM_ADDED_SUCCESS = 'Program added successfully.';
    static readonly PROGRAM_UPDATED_SUCCESS = 'Program updated successfully.';
    static readonly STAFF_SAVED_SUCCESS = 'Staff invitation sent successfully';
    static readonly STAFF_STATUS_UPDATED_SUCCESS = 'Staff user status updated successfully';
    static readonly STAFF_UPDATED_SUCCESS = 'Staff user updated successfully';
}
